import  ApiService  from '../../services/api.service';

const state={
    menusList: [],
}
const getters = {
    menusList : (state)=> {
        return state.menusList;
    }
}
const actions = {
    async fetchMenus({commit}) {
        await ApiService.get('/menus').then((result) => {
            commit('setMenusList',result.data);
        }).catch((e) => {
            
        }).finally(() => {
            // commit('setLoading', false)
        })
    }
}
const mutations = {
    setMenusList(state,status){
        state.menusList=status
   },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}